'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        height: "24px",
        fontSize: variables.SIZES.TEXT_SMALL,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        color: variables.COLORS.TEXT_PRIMARY,
        backgroundColor: variables.COLORS.WHITE,
        "&.sprout-focus-visible": {
            borderColor: variables.COLORS.MISC_FOCUS_BORDER,
            boxShadow: `0px 0px 0px 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
        "&$disabled": {
            backgroundColor: variables.COLORS.GREYSCALE_0_05,
            color: variables.COLORS.GREYSCALE_0_30,
            border: "none",
            opacity: 1,
        },
    },
    outlined: {
        border: `solid 1px ${variables.COLORS.GREYSCALE_0_15}`,
        backgroundColor: variables.COLORS.GREYSCALE_98,
        "$clickable&:active ": {
            boxSizing: "border-box",
            borderRadius: variables.SIZES.BORDER_RADIUS,
            boxShadow: "none",
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
        },
        "& $deleteIconSmall": {
            height: 13,
            color: "inherit",
        },
    },
    label: {
        fontFamily: variables.VARIOUS.FONT_FAMILY,
        lineHeight: "16px",
    },
};

var MuiChip = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiChip = MuiChip;
exports.light = light;
